import { AppState } from "../../../redux-configuration/AppState";

export const storedTokenSelector = (appState: AppState): string | null => appState.authentication.token.token
export const loadStoredTokenLoadingSelector = (appState: AppState): boolean => appState.authentication.token.loading
export const loadStoredTokenErrorSelector = (appState: AppState): boolean | null => appState.authentication.token.error
